import { composeClassNames, withDefault } from "@faedev/editor-utils";
import { CSSProperties } from "react";
import { sHr } from "src/styles/sHr.module.scss";

type Props = {
  style?: CSSProperties | null | undefined;
  className?: (string | string) | null | undefined;
  type?: "horizontal" | "vertical";
  variant?: ("default" | "light" | "lighter") | null | undefined;
  width?: (1 | 2 | 3 | 4 | 5) | null | undefined;
};

function Hr({ style, className, type, variant, width }: Props) {
  return (
    <div
      className={composeClassNames([
        sHr,
        `hr`,
        withDefault(type, `horizontal`),
        withDefault(variant, `default`),
        withDefault(width ? `width-${width}` : null, `width-1`),
        className,
      ])}
      style={style}
    >
      &nbsp;
    </div>
  );
}

export default Hr;
